import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import makeStyles from "@material-ui/core/styles/makeStyles"
import CallIcon from "@material-ui/icons/Call"
import React from "react"
import Logo from "./logo.svg"

const useStyles = makeStyles((theme) => ({
	root: {
		margin: "auto",
		color: theme.palette.primary.main,
	},
}))

const LogoAndPhone = () => {
	const classes = useStyles()
	return (
		<Grid item className={classes.root}>
			<a href='https://nobaar.com'>
				<img alt={"logo"} src={Logo} />
			</a>
			<Button component={"a"} className={classes.root} href='tel:02171400698'>
				۰۲۱-۷۱۴۰۰۶۹۸
				<CallIcon />
			</Button>
		</Grid>
	)
}

export default LogoAndPhone
